import { createSvgIcon } from '@mui/material/utils';

export const GotoSettingsIcon = createSvgIcon(
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M15 20.66V15H20.66V17H18.42L21.37 19.95L19.96 21.36L17 18.41V20.65H15V20.66Z'
      fill='currentColor'
    />
    <path
      d='M19.2 12.0004C19.2 12.3304 19.18 12.6404 19.14 12.9404L19.2158 13H15.4579C15.5504 12.6823 15.6 12.3469 15.6 12.0004C15.6 10.0204 13.98 8.40039 12 8.40039C10.02 8.40039 8.39999 10.0204 8.39999 12.0004C8.39999 13.9804 10.02 15.6004 12 15.6004C12.3466 15.6004 12.6822 15.5507 13 15.4582V21.6004H10.08C9.83999 21.6004 9.64999 21.4304 9.59999 21.1904L9.23999 18.6504C8.64999 18.4104 8.11999 18.0904 7.61999 17.7104L5.22999 18.6704C5.00999 18.7404 4.75999 18.6704 4.63999 18.4504L2.71999 15.1304C2.60999 14.9304 2.65999 14.6604 2.83999 14.5204L4.86999 12.9404C4.81999 12.6404 4.79999 12.3104 4.79999 12.0004C4.79999 11.6904 4.83999 11.3604 4.88999 11.0604L2.85999 9.48039C2.65999 9.34039 2.61999 9.08039 2.73999 8.87039L4.64999 5.55039C4.76999 5.33039 5.01999 5.25039 5.23999 5.33039L7.62999 6.29039C8.11999 5.92039 8.65999 5.59039 9.24999 5.35039L9.60999 2.81039C9.64999 2.57039 9.83999 2.40039 10.08 2.40039H13.92C14.16 2.40039 14.36 2.57039 14.4 2.81039L14.76 5.35039C15.35 5.59039 15.88 5.91039 16.38 6.29039L18.77 5.33039C18.99 5.26039 19.24 5.33039 19.36 5.55039L21.28 8.87039C21.39 9.07039 21.34 9.34039 21.16 9.48039L19.13 11.0604C19.18 11.3604 19.2 11.6804 19.2 12.0004Z'
      fill='currentColor'
    />
  </svg>,
  'GotoSettings',
);

export const CashAssistIcon = createSvgIcon(
  <svg width='35' height='30' viewBox='0 0 35 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M9.79673 0H33.7414C34.0291 0.00143086 34.3047 0.114978 34.5076 0.315816C34.7106 0.516653 34.8246 0.78844 34.8246 1.07175V28.93C34.8246 29.0707 34.7964 29.21 34.7417 29.3399C34.6869 29.4698 34.6067 29.5879 34.5056 29.6873C34.4045 29.7866 34.2844 29.8654 34.1524 29.9191C34.0203 29.9727 33.8787 30.0002 33.7359 30H9.79673C9.65385 30.0002 9.51231 29.9727 9.38023 29.9191C9.24816 29.8654 9.12812 29.7866 9.027 29.6873C8.92588 29.5879 8.84565 29.4698 8.79092 29.3399C8.73618 29.21 8.70801 29.0707 8.70801 28.93V1.07175C8.70801 0.787505 8.82271 0.514901 9.02689 0.313908C9.23106 0.112916 9.50799 0 9.79673 0V0Z'
      fill='url(#paint0_linear_8246_17494)'
    />
    <path
      d='M34.8301 7.50049H8.70801V15.0009H34.8301V7.50049Z'
      fill='url(#paint1_linear_8246_17494)'
    />
    <path
      d='M8.70801 7.50045V1.07175C8.70801 0.787505 8.82271 0.514901 9.02689 0.313908C9.23106 0.112916 9.50799 0 9.79673 0L33.7414 0C34.0291 0.00143086 34.3047 0.114978 34.5076 0.315816C34.7106 0.516653 34.8246 0.78844 34.8246 1.07175V7.50045H8.70801Z'
      fill='url(#paint2_linear_8246_17494)'
    />
    <path
      d='M34.8246 22.5015V28.9302C34.8246 29.0708 34.7964 29.2101 34.7417 29.34C34.6869 29.47 34.6067 29.588 34.5056 29.6874C34.4045 29.7867 34.2844 29.8655 34.1524 29.9192C34.0203 29.9728 33.8787 30.0003 33.7359 30.0001H9.79673C9.65385 30.0003 9.51231 29.9728 9.38023 29.9192C9.24816 29.8655 9.12812 29.7867 9.027 29.6874C8.92588 29.588 8.84565 29.47 8.79092 29.34C8.73618 29.2101 8.70801 29.0708 8.70801 28.9302V22.5015H34.8246Z'
      fill='url(#paint3_linear_8246_17494)'
    />
    <path
      d='M34.8301 15.001H8.70801V22.5014H34.8301V15.001Z'
      fill='url(#paint4_linear_8246_17494)'
    />
    <path
      d='M17.4141 15C17.4141 10.2662 13.5158 6.42871 8.70705 6.42871C3.89828 6.42871 0 10.2662 0 15C0 19.7338 3.89828 23.5713 8.70705 23.5713C13.5158 23.5713 17.4141 19.7338 17.4141 15Z'
      fill='url(#paint5_linear_8246_17494)'
    />
    <path
      d='M6.40419 18.8278C5.70442 18.4641 5.11979 17.9179 4.71428 17.249C4.31068 16.5536 4.09839 15.7666 4.09839 14.9657C4.09839 14.1648 4.31068 13.3777 4.71428 12.6823C5.11979 12.0134 5.70442 11.4673 6.40419 11.1036C7.14978 10.7182 7.98155 10.5228 8.82358 10.5352C9.52558 10.525 10.2221 10.6583 10.8691 10.9268C11.4642 11.1773 11.9906 11.5631 12.405 12.0526L11.111 13.2272C10.8464 12.9088 10.5121 12.6531 10.1332 12.4795C9.75432 12.3058 9.34049 12.2185 8.92255 12.224C8.4192 12.2151 7.92213 12.3351 7.48008 12.5723C7.06425 12.7991 6.72183 13.1368 6.49216 13.5466C6.25993 13.9847 6.13864 14.4715 6.13864 14.9657C6.13864 15.4598 6.25993 15.9467 6.49216 16.3847C6.72183 16.7945 7.06425 17.1322 7.48008 17.3591C7.92213 17.5962 8.4192 17.7162 8.92255 17.7073C9.34166 17.7122 9.75641 17.6232 10.1355 17.4473C10.5146 17.2713 10.8482 17.0129 11.111 16.6915L12.405 17.8625C11.9922 18.359 11.4633 18.7497 10.8636 19.001C10.214 19.2693 9.51511 19.4026 8.81075 19.3925C7.97322 19.4052 7.14582 19.211 6.40419 18.8278Z'
      fill='white'
    />
    <defs>
      <linearGradient
        id='paint0_linear_8246_17494'
        x1='34.8301'
        y1='15.0009'
        x2='8.70801'
        y2='15.0009'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FF8F00' />
        <stop offset='1' stopColor='#FFCA00' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_8246_17494'
        x1='34.8301'
        y1='11.2509'
        x2='8.70937'
        y2='11.2509'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFCA00' />
        <stop offset='1' stopColor='#FF8F00' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_8246_17494'
        x1='8.70801'
        y1='3.7503'
        x2='34.8251'
        y2='3.7503'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFCA00' />
        <stop offset='1' stopColor='#FF8F00' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_8246_17494'
        x1='34.8246'
        y1='26.251'
        x2='8.70937'
        y2='26.251'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFCA00' />
        <stop offset='1' stopColor='#FF8F00' />
      </linearGradient>
      <linearGradient
        id='paint4_linear_8246_17494'
        x1='8.70801'
        y1='18.7513'
        x2='34.8306'
        y2='18.7513'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFCA00' />
        <stop offset='1' stopColor='#FF8F00' />
      </linearGradient>
      <linearGradient
        id='paint5_linear_8246_17494'
        x1='0'
        y1='15.0002'
        x2='17.4144'
        y2='15.0002'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFCA00' />
        <stop offset='1' stopColor='#FF8F00' />
      </linearGradient>
    </defs>
  </svg>,
  'CashAssist',
);

export const UnpinIcon = createSvgIcon(
  <svg width='20' height='21' viewBox='0 0 20 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_10249_32976)'>
      <path
        d='M16.8974 16.5759L12.4906 12.1692H10.8403V18.0019L10.007 18.8351L9.17378 18.0019V12.1692H4.19849L4.19906 10.5021C5.58204 10.5019 6.69853 9.38533 6.6988 8.00236L6.69822 6.37673L2.16602 1.84453L3.34453 0.666016L18.0759 15.3974L16.8974 16.5759Z'
        fill='#2196F3'
      />
      <path
        d='M14.1986 2.16908C14.6569 2.16908 15.0318 2.54399 15.0318 3.00232C15.0316 3.46045 14.6568 3.83557 14.1986 3.83557H13.3653V8.00179C13.3654 8.46114 13.4908 8.8903 13.706 9.25971L6.61478 2.1685L14.1986 2.16908Z'
        fill='#2196F3'
      />
      <path
        d='M15.8656 11.4194L14.6077 10.1614C14.9771 10.3766 15.4063 10.5021 15.8656 10.5021V11.4194Z'
        fill='#2196F3'
      />
    </g>
    <defs>
      <clipPath id='clip0_10249_32976'>
        <rect width='20' height='20' fill='white' transform='translate(0 0.5)' />
      </clipPath>
    </defs>
  </svg>,
  'Unpin',
);

export const UnpinGreyIcon = createSvgIcon(
  <svg width='20' height='22' viewBox='0 0 20 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M18.2776 19.2911L12.9895 14.003H11.0091V21.0022L10.0092 22.0021L9.0093 21.0022V14.003H3.03894L3.03963 12.0025C4.6992 12.0022 6.039 10.6624 6.03931 9.00284L6.03862 7.05208L0.599976 1.61343L2.01419 0.199219L19.6919 17.8769L18.2776 19.2911Z'
      fill='black'
      fill-opacity='0.56'
    />
    <path
      d='M15.039 2.00289C15.589 2.00289 16.0389 2.45279 16.0389 3.00279C16.0386 3.55254 15.5889 4.00268 15.039 4.00268H14.0391V9.00215C14.0392 9.55337 14.1897 10.0684 14.4479 10.5117L5.93849 2.0022L15.039 2.00289Z'
      fill='black'
      fill-opacity='0.56'
    />
    <path
      d='M17.0395 13.1032L15.53 11.5937C15.9733 11.8519 16.4883 12.0025 17.0395 12.0025V13.1032Z'
      fill='black'
      fill-opacity='0.56'
    />
  </svg>,
  'UnpinGrey',
);

export const WawiAssistIcon = createSvgIcon(
  <svg width='35' height='30' viewBox='0 0 35 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M33.826 0H9.88191C9.59317 0 9.31626 0.112916 9.11209 0.313908C8.90792 0.514901 8.79321 0.787505 8.79321 1.07175V28.93C8.79321 29.0707 8.82139 29.21 8.87612 29.3399C8.93086 29.4698 9.01108 29.5879 9.1122 29.6873C9.21332 29.7866 9.33335 29.8654 9.46542 29.9191C9.5975 29.9727 9.73903 30.0002 9.88191 30H33.826C33.9689 30.0002 34.1104 29.9727 34.2425 29.9191C34.3746 29.8654 34.4946 29.7866 34.5957 29.6873C34.6968 29.5879 34.7771 29.4698 34.8318 29.3399C34.8865 29.21 34.9147 29.0707 34.9147 28.93V1.07175C34.9147 0.787505 34.8 0.514901 34.5958 0.313908C34.3917 0.112916 34.1147 0 33.826 0V0Z'
      fill='url(#paint0_linear_8246_17387)'
    />
    <path
      d='M34.9147 7.50049H8.79321V15.0009H34.9147V7.50049Z'
      fill='url(#paint1_linear_8246_17387)'
    />
    <path
      d='M34.9092 7.50045V1.07175C34.9092 0.78844 34.7953 0.516653 34.5923 0.315816C34.3893 0.114978 34.1138 0.00143086 33.826 0L9.88191 0C9.59317 0 9.31626 0.112916 9.11209 0.313909C8.90792 0.514901 8.79321 0.787505 8.79321 1.07175V7.50045H34.9092Z'
      fill='url(#paint2_linear_8246_17387)'
    />
    <path
      d='M8.79321 22.501V28.9297C8.79321 29.0703 8.82139 29.2096 8.87612 29.3395C8.93086 29.4695 9.01108 29.5875 9.1122 29.6869C9.21332 29.7863 9.33335 29.865 9.46542 29.9187C9.5975 29.9724 9.73903 29.9999 9.88191 29.9996H33.826C33.9689 29.9999 34.1104 29.9724 34.2425 29.9187C34.3746 29.865 34.4946 29.7863 34.5957 29.6869C34.6968 29.5875 34.7771 29.4695 34.8318 29.3395C34.8865 29.2096 34.9147 29.0703 34.9147 28.9297V22.501H8.79321Z'
      fill='url(#paint3_linear_8246_17387)'
    />
    <path
      d='M34.9147 15.0007H8.79321V22.5012H34.9147V15.0007Z'
      fill='url(#paint4_linear_8246_17387)'
    />
    <path
      d='M17.4992 15C17.4992 10.2662 13.601 6.42871 8.79231 6.42871C3.98364 6.42871 0.0854492 10.2662 0.0854492 15C0.0854492 19.7338 3.98364 23.5713 8.79231 23.5713C13.601 23.5713 17.4992 19.7338 17.4992 15Z'
      fill='url(#paint5_linear_8246_17387)'
    />
    <path
      d='M14.5868 11.9844L12.2151 19.1258H10.4134L8.81887 14.2957L7.16932 19.1258H5.38048L2.9978 11.9916H4.73716L6.37204 17.0057L8.08207 11.9916H9.63448L11.284 17.0436L12.9721 11.9916L14.5868 11.9844Z'
      fill='white'
    />
    <defs>
      <linearGradient
        id='paint0_linear_8246_17387'
        x1='8.79321'
        y1='15.0009'
        x2='34.9147'
        y2='15.0009'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FD2724' />
        <stop offset='1' stopColor='#C60008' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_8246_17387'
        x1='8.794'
        y1='15.0005'
        x2='34.9155'
        y2='15.0005'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#C60008' />
        <stop offset='1' stopColor='#FD2724' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_8246_17387'
        x1='8.794'
        y1='7.5'
        x2='34.91'
        y2='7.5'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FD2724' />
        <stop offset='1' stopColor='#C60008' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_8246_17387'
        x1='8.794'
        y1='29.9992'
        x2='34.9155'
        y2='29.9992'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#C60008' />
        <stop offset='1' stopColor='#FD2724' />
      </linearGradient>
      <linearGradient
        id='paint4_linear_8246_17387'
        x1='8.794'
        y1='22.5007'
        x2='34.9155'
        y2='22.5007'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FD2724' />
        <stop offset='1' stopColor='#C60008' />
      </linearGradient>
      <linearGradient
        id='paint5_linear_8246_17387'
        x1='0.0859716'
        y1='23.5703'
        x2='17.4997'
        y2='23.5703'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FD2724' />
        <stop offset='1' stopColor='#C60008' />
      </linearGradient>
    </defs>
  </svg>,
  'WawiAssist',
);

export const RezeptAssistIcon = createSvgIcon(
  <svg width='35' height='30' viewBox='0 0 35 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M33.7418 0H9.7962C9.19503 0 8.70776 0.479653 8.70776 1.07142V7.49994V14.9999V22.4998V28.9283C8.70776 29.5201 9.19503 29.9997 9.7962 29.9997H33.7418C34.3429 29.9997 34.8302 29.5201 34.8302 28.9283V22.4998V14.9999V7.49994V1.07142C34.8302 0.479653 34.3429 0 33.7418 0Z'
      fill='url(#paint0_linear_8246_18982)'
    />
    <rect
      x='8.70776'
      y='7.5'
      width='26.1224'
      height='7.49994'
      fill='url(#paint1_linear_8246_18982)'
    />
    <path
      d='M34.8302 7.49994V1.07142C34.8302 0.479653 34.3429 0 33.7418 0H9.7962C9.19503 0 8.70776 0.479653 8.70776 1.07142V7.49994H34.8302Z'
      fill='url(#paint2_linear_8246_18982)'
    />
    <path
      d='M8.70776 22.5V28.9285C8.70776 29.5203 9.19503 29.9999 9.7962 29.9999H33.7418C34.3429 29.9999 34.8302 29.5203 34.8302 28.9285V22.5H8.70776Z'
      fill='url(#paint3_linear_8246_18982)'
    />
    <rect
      x='8.70776'
      y='15'
      width='26.1224'
      height='7.49994'
      fill='url(#paint4_linear_8246_18982)'
    />
    <path
      d='M8.70737 6.42871C3.89847 6.42871 0 10.2662 0 15C0 19.7337 3.89847 23.5712 8.70737 23.5712C13.5163 23.5712 17.4147 19.7337 17.4147 15C17.4147 10.2662 13.5163 6.42871 8.70737 6.42871Z'
      fill='url(#paint5_linear_8246_18982)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.79108 16.8968L10.4695 19.2836V19.284H12.633L10.6809 16.5299C11.2528 16.2852 11.6944 15.9324 12.0051 15.4713C12.3161 15.0101 12.4714 14.4612 12.4714 13.8249C12.4714 13.1886 12.3178 12.638 12.0113 12.1728C11.7048 11.7076 11.2674 11.3486 10.6997 11.0956C10.1316 10.8426 9.46223 10.7161 8.69147 10.7161H4.92407V19.2836H6.9382V16.8968H8.69147H8.79108ZM8.57967 12.3318C9.18464 12.3318 9.64473 12.4604 9.95992 12.7175C10.2748 12.9746 10.4325 13.3439 10.4325 13.8252C10.4325 14.2987 10.2748 14.6658 9.95992 14.9267C9.64473 15.188 9.18464 15.3183 8.57967 15.3183H6.93855V12.3318H8.57967Z'
      fill='white'
    />
    <defs>
      <linearGradient
        id='paint0_linear_8246_18982'
        x1='8.70776'
        y1='29.9997'
        x2='34.8302'
        y2='29.9997'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#00BB65' />
        <stop offset='1' stopColor='#007E27' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_8246_18982'
        x1='8.70776'
        y1='14.9999'
        x2='34.8302'
        y2='14.9999'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#007E27' />
        <stop offset='1' stopColor='#00BB65' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_8246_18982'
        x1='8.70776'
        y1='7.49994'
        x2='34.8302'
        y2='7.49994'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#00BB65' />
        <stop offset='1' stopColor='#007E27' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_8246_18982'
        x1='34.8302'
        y1='22.5'
        x2='8.70776'
        y2='22.5'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#00BB65' />
        <stop offset='1' stopColor='#007E27' />
      </linearGradient>
      <linearGradient
        id='paint4_linear_8246_18982'
        x1='8.70776'
        y1='22.4999'
        x2='34.8302'
        y2='22.4999'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#00BB65' />
        <stop offset='1' stopColor='#007E27' />
      </linearGradient>
      <linearGradient
        id='paint5_linear_8246_18982'
        x1='0'
        y1='23.5712'
        x2='17.4147'
        y2='23.5712'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#00BB65' />
        <stop offset='1' stopColor='#007E27' />
      </linearGradient>
    </defs>
  </svg>,
  'RezeptAssist',
);

export const SmartPickingIcon = createSvgIcon(
  <svg width='35' height='30' viewBox='0 0 35 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M33.7333 0H9.79093C9.19042 0 8.69434 0.488014 8.69434 1.07877V28.9212C8.69434 29.512 9.19042 30 9.79093 30H33.7333C34.3338 30 34.8299 29.512 34.8299 28.9212V1.07877C34.8038 0.488014 34.3338 0 33.7333 0Z'
      fill='url(#paint0_linear_8246_17425)'
    />
    <path d='M34.8038 7.5H8.69434V15H34.8038V7.5Z' fill='url(#paint1_linear_8246_17425)' />
    <path
      d='M34.8038 7.5V1.07877C34.8038 0.488014 34.3077 0 33.7072 0H9.79093C9.19042 0 8.69434 0.488014 8.69434 1.07877V7.5H34.8038Z'
      fill='url(#paint2_linear_8246_17425)'
    />
    <path
      d='M8.69434 22.4744V28.8956C8.69434 29.4864 9.19042 29.9744 9.79093 29.9744H33.7333C34.3338 29.9744 34.8299 29.4864 34.8299 28.8956V22.4744H8.69434Z'
      fill='url(#paint3_linear_8246_17425)'
    />
    <path
      d='M34.8038 14.9744H8.69434V22.4744H34.8038V14.9744Z'
      fill='url(#paint4_linear_8246_17425)'
    />
    <path
      opacity='0.05'
      d='M8.69434 27.817C15.9005 27.817 21.7491 22.0636 21.7491 14.9745C21.7491 7.8855 15.9005 2.13208 8.69434 2.13208V27.817Z'
      fill='url(#paint5_radial_8246_17425)'
    />
    <path
      d='M8.69445 6.42114C3.89031 6.42114 0 10.2482 0 14.9742C0 19.7003 3.89031 23.5273 8.69445 23.5273C13.4986 23.5273 17.3889 19.7003 17.3889 14.9742C17.415 10.2482 13.4986 6.42114 8.69445 6.42114Z'
      fill='url(#paint6_linear_8246_17425)'
    />
    <path
      d='M8.61632 19.3922C7.91136 19.3922 7.25862 19.2894 6.60589 19.1096C5.97926 18.9298 5.45707 18.6987 5.06543 18.3905L5.74428 16.9007C6.10981 17.1576 6.55367 17.3887 7.07586 17.5428C7.59805 17.7226 8.09413 17.7997 8.61632 17.7997C9.00796 17.7997 9.34738 17.774 9.58237 17.6713C9.81735 17.5942 10.0001 17.4915 10.1307 17.3374C10.2351 17.2089 10.3134 17.0291 10.3134 16.8494C10.3134 16.6182 10.2351 16.4384 10.0523 16.31C9.86957 16.1815 9.63458 16.0531 9.32127 15.9761C9.03407 15.899 8.69464 15.7963 8.32911 15.7192C7.96358 15.6422 7.59805 15.5394 7.25862 15.4367C6.89309 15.3339 6.57978 15.1798 6.26646 15C5.97926 14.8202 5.71817 14.5891 5.5354 14.2809C5.35263 13.9983 5.2482 13.6131 5.2482 13.1507C5.2482 12.6627 5.37874 12.2261 5.63984 11.8151C5.90093 11.4041 6.31868 11.0959 6.86698 10.8391C7.41528 10.6079 8.09413 10.4795 8.90352 10.4795C9.45182 10.4795 10.0001 10.5309 10.5223 10.6593C11.0445 10.7877 11.5145 10.9675 11.9322 11.2244L11.3056 12.7398C10.8878 12.5086 10.4962 12.3545 10.0784 12.2261C9.66069 12.1233 9.26905 12.072 8.87741 12.072C8.48577 12.072 8.17245 12.1233 7.91136 12.2004C7.65027 12.2774 7.49361 12.4059 7.38917 12.56C7.28473 12.7141 7.23251 12.8682 7.23251 13.048C7.23251 13.2791 7.31084 13.4333 7.49361 13.5874C7.67638 13.7158 7.91136 13.8185 8.22467 13.9213C8.51188 13.9983 8.8513 14.0754 9.21683 14.1781C9.58236 14.2552 9.9479 14.3579 10.2873 14.4607C10.6529 14.5634 10.9662 14.7175 11.2795 14.8973C11.5667 15.0771 11.8278 15.3083 12.0105 15.6165C12.1933 15.899 12.2977 16.2843 12.2977 16.7209C12.2977 17.2089 12.1672 17.6456 11.88 18.0309C11.6189 18.4418 11.2012 18.75 10.6529 19.0069C10.1307 19.2894 9.45182 19.3922 8.61632 19.3922Z'
      fill='white'
    />
    <defs>
      <linearGradient
        id='paint0_linear_8246_17425'
        x1='8.69434'
        y1='15'
        x2='34.8299'
        y2='15'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FF8F00' />
        <stop offset='1' stopColor='#FFCA00' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_8246_17425'
        x1='8.69434'
        y1='11.25'
        x2='34.8038'
        y2='11.25'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#2D3AD4' />
        <stop offset='1' stopColor='#30B6FF' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_8246_17425'
        x1='8.69434'
        y1='3.75'
        x2='34.8038'
        y2='3.75'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#30B6FF' />
        <stop offset='1' stopColor='#2D3AD4' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_8246_17425'
        x1='34.8299'
        y1='26.2244'
        x2='8.69434'
        y2='26.2244'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#30B6FF' />
        <stop offset='1' stopColor='#2D3AD4' />
      </linearGradient>
      <linearGradient
        id='paint4_linear_8246_17425'
        x1='8.69434'
        y1='18.7244'
        x2='34.8038'
        y2='18.7244'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#30B6FF' />
        <stop offset='1' stopColor='#2D3AD4' />
      </linearGradient>
      <radialGradient
        id='paint5_radial_8246_17425'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(8.90582 15.0747) scale(12.8459 12.637)'
      >
        <stop stopColor='#231F20' />
        <stop offset='1' stopColor='#231F20' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint6_linear_8246_17425'
        x1='0'
        y1='14.9742'
        x2='17.3889'
        y2='14.9742'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#30B6FF' />
        <stop offset='1' stopColor='#2D3AD4' />
      </linearGradient>
    </defs>
  </svg>,
  'SmartPicking',
);

export const RestaurantManagerIcon = createSvgIcon(
  <svg width='35' height='30' viewBox='0 0 35 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M9.79444 0H33.7307C34.3304 0 34.8301 0.490196 34.8301 1.07843V28.9216C34.8301 29.5098 34.3304 30 33.7307 30H9.79444C9.19478 30 8.69507 29.5098 8.69507 28.9216V1.07843C8.69507 0.490196 9.19478 0 9.79444 0Z'
      fill='url(#paint0_linear_8246_24150)'
    />
    <path d='M34.8301 7.5H8.69507V15H34.8301V7.5Z' fill='url(#paint1_linear_8246_24150)' />
    <path
      d='M8.69507 7.5V1.07843C8.69507 0.490196 9.19478 0 9.79444 0H33.7307C34.3304 0 34.8301 0.490196 34.8301 1.07843V7.5H8.69507Z'
      fill='url(#paint2_linear_8246_24150)'
    />
    <path
      d='M34.8301 22.4509V28.8725C34.8301 29.4607 34.3304 29.9509 33.7307 29.9509H9.79444C9.19478 29.9509 8.69507 29.4607 8.69507 28.8725V22.4509H34.8301Z'
      fill='url(#paint3_linear_8246_24150)'
    />
    <path
      d='M34.8301 14.9509H8.69507V22.4509H34.8301V14.9509Z'
      fill='url(#paint4_linear_8246_24150)'
    />
    <path
      d='M8.69501 6.47729C3.89776 6.47729 0 10.3008 0 15.0067C0 19.7126 3.89776 23.5361 8.69501 23.5361C13.4923 23.5361 17.39 19.7126 17.39 15.0067C17.44 10.3008 13.5422 6.47729 8.69501 6.47729Z'
      fill='url(#paint5_linear_8246_24150)'
    />
    <path
      d='M11.3376 18.75L11.3248 14.2525L9.09485 17.9583H8.30331L6.08613 14.3494V18.75H4.43921V11.25H5.89037L8.72462 15.9117L11.5163 11.25H12.9547L12.976 18.75H11.3291H11.3376Z'
      fill='white'
    />
    <defs>
      <linearGradient
        id='paint0_linear_8246_24150'
        x1='34.8301'
        y1='15'
        x2='8.69507'
        y2='15'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#199B70' />
        <stop offset='1' stopColor='#34CB9E' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_8246_24150'
        x1='8.69507'
        y1='11.25'
        x2='34.8301'
        y2='11.25'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#199B70' />
        <stop offset='1' stopColor='#34CB9E' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_8246_24150'
        x1='34.8301'
        y1='3.75'
        x2='8.69507'
        y2='3.75'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#199B70' />
        <stop offset='1' stopColor='#34CB9E' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_8246_24150'
        x1='8.69507'
        y1='26.2009'
        x2='34.8301'
        y2='26.2009'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#199B70' />
        <stop offset='1' stopColor='#34CB9E' />
      </linearGradient>
      <linearGradient
        id='paint4_linear_8246_24150'
        x1='34.8301'
        y1='18.7009'
        x2='8.69507'
        y2='18.7009'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#199B70' />
        <stop offset='1' stopColor='#34CB9E' />
      </linearGradient>
      <linearGradient
        id='paint5_linear_8246_24150'
        x1='17.3905'
        y1='15.0067'
        x2='0'
        y2='15.0067'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#199B70' />
        <stop offset='1' stopColor='#34CB9E' />
      </linearGradient>
    </defs>
  </svg>,
  'RestaurantManager',
);

export const RunMyRestoIcon = createSvgIcon(
  <svg fill='none' xmlns='http://www.w3.org/2000/svg' viewBox='18 0 50 50'>
    <g clipPath='url(#clip0_416_10934)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M30.334 46.994C33.382 47.364 37.368 47.368 43 47.368C48.632 47.368 52.618 47.364 55.666 46.994C58.654 46.63 60.386 45.95 61.678 44.846C62.098 44.488 62.488 44.098 62.846 43.678C63.95 42.386 64.63 40.654 64.994 37.666C65.364 34.618 65.368 30.632 65.368 25C65.368 19.368 65.364 15.382 64.994 12.334C64.63 9.346 63.95 7.614 62.846 6.322C62.488 5.902 62.098 5.512 61.678 5.154C60.386 4.05 58.654 3.37 55.666 3.006C52.618 2.636 48.632 2.632 43 2.632C37.368 2.632 33.382 2.636 30.334 3.006C27.346 3.368 25.614 4.05 24.322 5.154C23.902 5.512 23.512 5.902 23.154 6.322C22.05 7.614 21.37 9.346 21.006 12.334C20.636 15.382 20.632 19.368 20.632 25C20.632 30.632 20.636 34.618 21.006 37.666C21.368 40.654 22.05 42.386 23.154 43.678C23.512 44.098 23.902 44.488 24.322 44.846C25.614 45.95 27.346 46.63 30.334 46.994ZM21.152 4.612C18 8.304 18 13.87 18 25C18 36.13 18 41.696 21.152 45.388C21.6 45.912 22.088 46.4 22.612 46.848C26.304 50 31.868 50 43 50C54.132 50 59.696 50 63.388 46.848C63.912 46.4 64.4 45.912 64.848 45.388C68 41.696 68 36.132 68 25C68 13.868 68 8.304 64.848 4.612C64.4 4.088 63.912 3.6 63.388 3.152C59.696 0 54.13 0 43 0C31.87 0 26.304 0 22.612 3.152C22.088 3.6 21.6 4.088 21.152 4.612Z'
        fill='url(#paint0_linear_416_10934)'
      />
      <path
        d='M47.658 35.652L43.682 29.718H39.294V35.652H34.522V14.348H43.446C45.272 14.348 46.852 14.662 48.188 15.292C49.542 15.92 50.584 16.814 51.31 17.97C52.036 19.126 52.4 20.496 52.4 22.078C52.4 23.66 52.026 25.03 51.28 26.186C50.554 27.322 49.514 28.194 48.158 28.804L52.782 35.652H47.658ZM47.57 22.078C47.57 20.88 47.196 19.968 46.45 19.338C45.704 18.688 44.614 18.364 43.18 18.364H39.292V25.79H43.18C44.614 25.79 45.704 25.466 46.45 24.816C47.196 24.166 47.57 23.254 47.57 22.076V22.078Z'
        fill='url(#paint1_linear_416_10934)'
      />
    </g>
    <defs>
      <linearGradient
        id='paint0_linear_416_10934'
        x1='21.672'
        y1='6.364'
        x2='66.454'
        y2='45.494'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFCA00' />
        <stop offset='0.96' stopColor='#FF8F00' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_416_10934'
        x1='33.854'
        y1='19.742'
        x2='52.332'
        y2='33.58'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFCA00' />
        <stop offset='0.96' stopColor='#FF8F00' />
      </linearGradient>
      <clipPath id='clip0_416_10934'>
        <rect width='50' height='50' fill='white' transform='translate(18)' />
      </clipPath>
    </defs>
  </svg>,
  'RunMyResto',
);

export const ConsoleIcon = createSvgIcon(
  <svg width='23' height='30' viewBox='0 0 23 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M3.85651 3.83936C-0.389029 8.06601 -1.2222 14.608 1.82068 19.7578L19.8389 1.81258C14.6732 -1.21676 8.09481 -0.387299 3.85651 3.83936Z'
      fill='url(#paint0_linear_6378_136988)'
    />
    <path
      d='M1.8208 19.7578C2.38591 20.7098 3.06693 21.5826 3.85663 22.3615L22.4617 3.83928C21.6792 3.0603 20.7953 2.37509 19.8462 1.8125L1.8208 19.7578Z'
      fill='url(#paint1_linear_6378_136988)'
    />
    <path
      d='M18.6434 26.1629C22.8889 21.9362 23.7221 15.3943 20.6792 10.2444L2.65381 28.1896C7.8267 31.219 14.4051 30.3823 18.6434 26.1629Z'
      fill='url(#paint2_linear_6378_136988)'
    />
    <path
      d='M0.0383301 26.1628C0.820784 26.9418 1.70467 27.627 2.65376 28.1896L20.6792 10.2443C20.1141 9.29223 19.4331 8.41949 18.6434 7.6333L0.0383301 26.1628Z'
      fill='url(#paint3_linear_6378_136988)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_6378_136988'
        x1='10.6106'
        y1='9.76765'
        x2='4.2774'
        y2='3.38156'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#C60008' />
        <stop offset='1' stopColor='#FD2724' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_6378_136988'
        x1='-7.83291'
        y1='31.0689'
        x2='20.6869'
        y2='2.42167'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#C60008' />
        <stop offset='1' stopColor='#FD2724' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_6378_136988'
        x1='18.9343'
        y1='25.767'
        x2='12.2487'
        y2='18.9162'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset='0.06' stopColor='#434343' />
        <stop offset='1' stopColor='#221F1F' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_6378_136988'
        x1='-3.29829'
        y1='31.1619'
        x2='31.6752'
        y2='-3.9679'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset='0.21' stopColor='#434343' />
        <stop offset='1' stopColor='#221F1F' />
      </linearGradient>
    </defs>
  </svg>,
  'Console',
);

export const GlobeWarningIcon = createSvgIcon(
  <svg
    width='150'
    height='150'
    viewBox='0 0 150 150'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M118.75 0C101.5 0 87.5 14 87.5 31.25C87.5 48.5 101.5 62.5 118.75 62.5C136 62.5 150 48.5 150 31.25C150 14 136 0 118.75 0ZM121.875 50H115.625V43.75H121.875V50ZM121.875 37.5H115.625V12.5H121.875V37.5Z'
      fill='#2196F3'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M78.6247 12.1068C77.4047 12.0359 76.1753 12 74.9375 12C40.4375 12 12.5 40 12.5 74.5C12.5 109 40.4375 137 74.9375 137C109.5 137 137.5 109 137.5 74.5C137.5 74.0124 137.494 73.526 137.483 73.041C133.571 74.8056 129.362 76.0273 124.951 76.61C124.785 80.1801 124.211 83.6556 123.375 87H102.25C102.75 82.875 103.125 78.75 103.125 74.5C103.125 74.373 103.125 74.2462 103.124 74.1195C98.3758 72.3288 94.01 69.7583 90.1829 66.5641C90.4516 69.1742 90.625 71.8247 90.625 74.5C90.625 78.75 90.1875 82.875 89.625 87H60.375C59.8125 82.875 59.375 78.75 59.375 74.5C59.375 70.25 59.8125 66.0625 60.375 62H85.4584C82.1703 58.3263 79.477 54.1092 77.5295 49.5H63.0625C65.6561 40.8748 69.5303 32.8317 74.4603 25.5392C75.1445 20.7805 76.5733 16.2624 78.6247 12.1068ZM25 74.5C25 78.8125 25.625 83 26.625 87H47.75C47.25 82.875 46.875 78.75 46.875 74.5C46.875 70.25 47.25 66.125 47.75 62H26.625C25.625 66 25 70.1875 25 74.5ZM50.1875 99.5H31.75C37.75 109.875 47.3125 117.812 58.8125 121.75C55.0625 114.812 52.1875 107.312 50.1875 99.5ZM31.75 49.5H50.1875C52.1875 41.6875 55.0625 34.1875 58.8125 27.25C47.3125 31.1875 37.75 39.125 31.75 49.5ZM63.0625 99.5C65.75 108.438 69.8125 116.75 75 124.25C80.1875 116.75 84.25 108.438 86.9375 99.5H63.0625ZM99.8125 99.5C97.8125 107.312 94.9375 114.812 91.1875 121.75C102.688 117.812 112.25 109.812 118.25 99.5H99.8125Z'
      fill='#2196F3'
    />
  </svg>,
  'GlobeWarning',
);

export const EdgeIcon = createSvgIcon(
  <svg
    width='25'
    height='24'
    viewBox='0 0 25 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <rect x='0.5' width='24' height='24' fill='url(#pattern5)' />
    <defs>
      <pattern id='pattern5' patternContentUnits='objectBoundingBox' width='1' height='1'>
        <use xlinkHref='#image0_5094_17555' transform='scale(0.0196078)' />
      </pattern>
      <image
        id='image0_5094_17555'
        width='51'
        height='51'
        xlinkHref='data:image/png;base64,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'
      />
    </defs>
  </svg>,
  'Edge',
);

export const OperaIcon = createSvgIcon(
  <svg
    width='25'
    height='24'
    viewBox='0 0 25 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <rect x='0.5' width='24' height='24' fill='url(#pattern4)' />
    <defs>
      <pattern id='pattern4' patternContentUnits='objectBoundingBox' width='1' height='1'>
        <use xlinkHref='#image0_5094_17549' transform='scale(0.0196078)' />
      </pattern>
      <image
        id='image0_5094_17549'
        width='51'
        height='51'
        xlinkHref='data:image/png;base64,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'
      />
    </defs>
  </svg>,
  'Opera',
);

export const SafariIcon = createSvgIcon(
  <svg
    width='25'
    height='24'
    viewBox='0 0 25 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <rect x='0.5' width='24' height='24' fill='url(#pattern3)' />
    <defs>
      <pattern id='pattern3' patternContentUnits='objectBoundingBox' width='1' height='1'>
        <use xlinkHref='#image0_5094_17558' transform='scale(0.0196078)' />
      </pattern>
      <image
        id='image0_5094_17558'
        width='51'
        height='51'
        xlinkHref='data:image/png;base64,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'
      />
    </defs>
  </svg>,
  'Safari',
);

export const FirefoxIcon = createSvgIcon(
  <svg
    width='25'
    height='24'
    viewBox='0 0 25 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <rect x='0.5' width='24' height='24' fill='url(#pattern1)' />
    <defs>
      <pattern id='pattern1' patternContentUnits='objectBoundingBox' width='1' height='1'>
        <use xlinkHref='#image0_5094_17552' transform='translate(0 -0.0196078) scale(0.0196078)' />
      </pattern>
      <image
        id='image0_5094_17552'
        width='51'
        height='53'
        xlinkHref='data:image/png;base64,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'
      />
    </defs>
  </svg>,
  'Firefox',
);

export const ChromeIcon = createSvgIcon(
  <svg
    width='25'
    height='24'
    viewBox='0 0 25 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <rect x='0.5' width='24' height='24' fill='url(#pattern2)' />
    <defs>
      <pattern id='pattern2' patternContentUnits='objectBoundingBox' width='1' height='1'>
        <use xlinkHref='#image0_5094_17547' transform='scale(0.0196078)' />
      </pattern>
      <image
        id='image0_5094_17547'
        width='51'
        height='51'
        xlinkHref='data:image/png;base64,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'
      />
    </defs>
  </svg>,
  'Chrome',
);

export const LogoIcon = createSvgIcon(
  <svg width='28' height='24' viewBox='0 0 28 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_300_25009)'>
      <path
        d='M27.1249 0H7.87572C7.64359 0 7.42097 0.090333 7.25684 0.251127C7.0927 0.411921 7.00049 0.630004 7.00049 0.8574V23.144C7.00049 23.2566 7.02314 23.368 7.06714 23.4719C7.11114 23.5759 7.17563 23.6703 7.25693 23.7498C7.33822 23.8293 7.43471 23.8923 7.54089 23.9353C7.64707 23.9782 7.76085 24.0002 7.87572 24H27.1249C27.2397 24.0002 27.3535 23.9782 27.4597 23.9353C27.5659 23.8923 27.6624 23.8293 27.7437 23.7498C27.825 23.6703 27.8895 23.5759 27.9335 23.4719C27.9775 23.368 28.0001 23.2566 28.0001 23.144V0.8574C28.0001 0.630004 27.9079 0.411921 27.7438 0.251127C27.5796 0.090333 27.357 0 27.1249 0V0Z'
        fill='url(#paint0_linear_300_25009)'
      />
      <path
        d='M28.0001 6.00037H7.00049V12.0007H28.0001V6.00037Z'
        fill='url(#paint1_linear_300_25009)'
      />
      <path
        d='M27.9957 6.00036V0.8574C27.9957 0.630752 27.9041 0.413322 27.7409 0.252653C27.5777 0.0919828 27.3562 0.00114469 27.1249 0L7.87572 0C7.64359 0 7.42097 0.090333 7.25684 0.251127C7.0927 0.411921 7.00049 0.630004 7.00049 0.8574V6.00036H27.9957Z'
        fill='url(#paint2_linear_300_25009)'
      />
      <path
        d='M7.00049 18.001V23.144C7.00049 23.2565 7.02314 23.3679 7.06714 23.4719C7.11114 23.5758 7.17563 23.6703 7.25693 23.7498C7.33822 23.8293 7.43471 23.8923 7.54089 23.9352C7.64707 23.9781 7.76085 24.0001 7.87572 24H27.1249C27.2397 24.0001 27.3535 23.9781 27.4597 23.9352C27.5659 23.8923 27.6624 23.8293 27.7437 23.7498C27.825 23.6703 27.8895 23.5758 27.9335 23.4719C27.9775 23.3679 28.0001 23.2565 28.0001 23.144V18.001H7.00049Z'
        fill='url(#paint3_linear_300_25009)'
      />
      <path
        d='M28.0001 12.0007H7.00049V18.001H28.0001V12.0007Z'
        fill='url(#paint4_linear_300_25009)'
      />
      <path
        d='M13.9993 12C13.9993 8.21301 10.8654 5.14301 6.99963 5.14301C3.13384 5.14301 0 8.21301 0 12C0 15.7871 3.13384 18.8571 6.99963 18.8571C10.8654 18.8571 13.9993 15.7871 13.9993 12Z'
        fill='url(#paint5_linear_300_25009)'
      />
      <path
        d='M11.6579 9.58734L9.75129 15.3005H8.30289L7.02099 11.4364L5.69488 15.3005H4.25679L2.34131 9.59312H3.73961L5.05393 13.6044L6.42866 9.59312H7.67667L9.00278 13.6347L10.3598 9.59312L11.6579 9.58734Z'
        fill='white'
      />
    </g>
    <defs>
      <linearGradient
        id='paint0_linear_300_25009'
        x1='7.00049'
        y1='12.0007'
        x2='28.0001'
        y2='12.0007'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FD2724' />
        <stop offset='1' stopColor='#C60008' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_300_25009'
        x1='7.00112'
        y1='12.0004'
        x2='28.0007'
        y2='12.0004'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#C60008' />
        <stop offset='1' stopColor='#FD2724' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_300_25009'
        x1='7.00112'
        y1='6'
        x2='27.9963'
        y2='6'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FD2724' />
        <stop offset='1' stopColor='#C60008' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_300_25009'
        x1='7.00112'
        y1='23.9996'
        x2='28.0007'
        y2='23.9996'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#C60008' />
        <stop offset='1' stopColor='#FD2724' />
      </linearGradient>
      <linearGradient
        id='paint4_linear_300_25009'
        x1='7.00112'
        y1='18.0007'
        x2='28.0007'
        y2='18.0007'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FD2724' />
        <stop offset='1' stopColor='#C60008' />
      </linearGradient>
      <linearGradient
        id='paint5_linear_300_25009'
        x1='0.000419978'
        y1='18.8563'
        x2='13.9997'
        y2='18.8563'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FD2724' />
        <stop offset='1' stopColor='#C60008' />
      </linearGradient>
      <clipPath id='clip0_300_25009'>
        <rect width='28' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>,
  'Logo',
);

export const LoadingAnimation = createSvgIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    preserveAspectRatio='xMidYMid meet'
    width='500'
    height='500'
    viewBox='0 0 500 500'
  >
    <defs>
      <animate
        repeatCount='indefinite'
        dur='1.3333333s'
        begin='0s'
        xlinkHref='#_R_G_L_3_G_D_0_P_0'
        fill='freeze'
        attributeName='fill'
        from='#e4e4e4'
        to='#e4e4e4'
        keyTimes='0;0.35;0.5625;0.6875;1'
        values='#e4e4e4;#2196f3;#2196f3;#e4e4e4;#e4e4e4'
        keySplines='0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0'
        calcMode='spline'
      />
      <animateMotion
        repeatCount='indefinite'
        dur='1.3333333s'
        begin='0s'
        xlinkHref='#_R_G_L_3_G'
        fill='freeze'
        keyTimes='0;0.325;0.4625;0.675;0.875;1'
        path='M390 326 C390,326 397.5,373 338,380 C298,385.5 188.17,378.83 150,359 C111.83,339.17 77.37,261.69 109,261 C131.83,260.5 110,326 110,326 C110,326 110,326 110,326 '
        keyPoints='0;0.18;0.58;0.85;1;1'
        keySplines='0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0'
        calcMode='spline'
      />
      <animateTransform
        repeatCount='indefinite'
        dur='1.3333333s'
        begin='0s'
        xlinkHref='#_R_G_L_3_G'
        fill='freeze'
        attributeName='transform'
        from='1 1'
        to='1 1'
        type='scale'
        additive='sum'
        keyTimes='0;0.325;0.4625;0.9;1'
        values='1 1;1.24 1.24;1.77 1.77;1 1;1 1'
        keySplines='0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0'
        calcMode='spline'
      />
      <animateTransform
        repeatCount='indefinite'
        dur='1.3333333s'
        begin='0s'
        xlinkHref='#_R_G_L_3_G'
        fill='freeze'
        attributeName='transform'
        from='152.445 6.035'
        to='152.445 6.035'
        type='translate'
        additive='sum'
        keyTimes='0;1'
        values='152.445 6.035;152.445 6.035'
        keySplines='0 0 1 1'
        calcMode='spline'
      />
      <animate
        repeatCount='indefinite'
        dur='1.3333333s'
        begin='0s'
        xlinkHref='#_R_G_L_2_G_D_0_P_0'
        fill='freeze'
        attributeName='fill'
        from='#e4e4e4'
        to='#e4e4e4'
        keyTimes='0;0.3125;0.5625;0.6875;1'
        values='#e4e4e4;#2196f3;#2196f3;#e4e4e4;#e4e4e4'
        keySplines='0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0'
        calcMode='spline'
      />
      <animateMotion
        repeatCount='indefinite'
        dur='1.3333333s'
        begin='0s'
        xlinkHref='#_R_G_L_2_G'
        fill='freeze'
        keyTimes='0;0.1625;0.3875;0.525;0.65;0.875;1'
        path='M296.67 327 C296.67,327 285.25,334.33 292.17,318.5 C299.08,302.67 321.5,226.33 338.17,232 C379.77,246.12 335.08,323 318.67,346.5 C302.25,370 286.65,381.92 239.67,373 C220.44,369.58 203.3,326 203.3,326 C203.3,326 203.3,326 203.3,326 '
        keyPoints='0;0.04;0.3;0.62;0.85;1;1'
        keySplines='0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0'
        calcMode='spline'
      />
      <animateTransform
        repeatCount='indefinite'
        dur='1.3333333s'
        begin='0s'
        xlinkHref='#_R_G_L_2_G'
        fill='freeze'
        attributeName='transform'
        from='1 1'
        to='1 1'
        type='scale'
        additive='sum'
        keyTimes='0;0.3875;0.875;1'
        values='1 1;1.75 1.75;1 1;1 1'
        keySplines='0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0'
        calcMode='spline'
      />
      <animateTransform
        repeatCount='indefinite'
        dur='1.3333333s'
        begin='0s'
        xlinkHref='#_R_G_L_2_G'
        fill='freeze'
        attributeName='transform'
        from='152.445 6.035'
        to='152.445 6.035'
        type='translate'
        additive='sum'
        keyTimes='0;1'
        values='152.445 6.035;152.445 6.035'
        keySplines='0 0 1 1'
        calcMode='spline'
      />
      <animate
        repeatCount='indefinite'
        dur='1.3333333s'
        begin='0s'
        xlinkHref='#_R_G_L_1_G_D_0_P_0'
        fill='freeze'
        attributeName='fill'
        from='#e4e4e4'
        to='#e4e4e4'
        keyTimes='0;0.25;0.5625;0.6875;1'
        values='#e4e4e4;#2196f3;#2196f3;#e4e4e4;#e4e4e4'
        keySplines='0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0'
        calcMode='spline'
      />
      <animateMotion
        repeatCount='indefinite'
        dur='1.3333333s'
        begin='0s'
        xlinkHref='#_R_G_L_1_G'
        fill='freeze'
        keyTimes='0;0.275;0.4375;0.6125;0.875;1'
        path='M203.33 326 C203.33,326 190.58,362.08 166.33,355 C138.67,346.92 113.24,234.21 145.33,207 C195.67,164.33 268.11,198.5 294.33,225 C330.8,261.85 296.7,327 296.7,327 C296.7,327 296.7,327 296.7,327 '
        keyPoints='0;0.11;0.44;0.78;1;1'
        keySplines='0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0'
        calcMode='spline'
      />
      <animateTransform
        repeatCount='indefinite'
        dur='1.3333333s'
        begin='0s'
        xlinkHref='#_R_G_L_1_G'
        fill='freeze'
        attributeName='transform'
        from='1 1'
        to='1 1'
        type='scale'
        additive='sum'
        keyTimes='0;0.25;0.6125;0.875;1'
        values='1 1;1.6300000000000001 1.6300000000000001;1.35 1.35;1 1;1 1'
        keySplines='0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0'
        calcMode='spline'
      />
      <animateTransform
        repeatCount='indefinite'
        dur='1.3333333s'
        begin='0s'
        xlinkHref='#_R_G_L_1_G'
        fill='freeze'
        attributeName='transform'
        from='152.445 6.035'
        to='152.445 6.035'
        type='translate'
        additive='sum'
        keyTimes='0;1'
        values='152.445 6.035;152.445 6.035'
        keySplines='0 0 1 1'
        calcMode='spline'
      />
      <animate
        repeatCount='indefinite'
        dur='1.3333333s'
        begin='0s'
        xlinkHref='#_R_G_L_0_G_D_0_P_0'
        fill='freeze'
        attributeName='fill'
        from='#e4e4e4'
        to='#e4e4e4'
        keyTimes='0;0.3125;0.5625;0.6875;1'
        values='#e4e4e4;#2196f3;#2196f3;#e4e4e4;#e4e4e4'
        keySplines='0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0'
        calcMode='spline'
      />
      <animateMotion
        repeatCount='indefinite'
        dur='1.3333333s'
        begin='0s'
        xlinkHref='#_R_G_L_0_G'
        fill='freeze'
        keyTimes='0;0.25;0.4;0.5;0.65;0.875;1'
        path='M110 326 C112.33,300.33 103.33,213.67 124,172 C144.67,130.33 186.93,73.32 234,76 C345,82.33 356.77,97.5 406,150 C447.33,190.33 424.77,229.74 404,264 C378.33,306.33 392.33,315.67 390,326 C390,326 390,326 390,326 '
        keyPoints='0;0.22;0.44;0.72;0.91;1;1'
        keySplines='0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0'
        calcMode='spline'
      />
      <animateTransform
        repeatCount='indefinite'
        dur='1.3333333s'
        begin='0s'
        xlinkHref='#_R_G_L_0_G'
        fill='freeze'
        attributeName='transform'
        from='1 1'
        to='1 1'
        type='scale'
        additive='sum'
        keyTimes='0;0.25;0.65;1'
        values='1 1;1.6765 1.6765;1 1;1 1'
        keySplines='0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0'
        calcMode='spline'
      />
      <animateTransform
        repeatCount='indefinite'
        dur='1.3333333s'
        begin='0s'
        xlinkHref='#_R_G_L_0_G'
        fill='freeze'
        attributeName='transform'
        from='152.445 6.035'
        to='152.445 6.035'
        type='translate'
        additive='sum'
        keyTimes='0;1'
        values='152.445 6.035;152.445 6.035'
        keySplines='0 0 1 1'
        calcMode='spline'
      />
      <animate
        attributeType='XML'
        attributeName='opacity'
        dur='1s'
        from='0'
        to='1'
        xlinkHref='#time_group'
      />
    </defs>
    <g id='_R_G'>
      <g id='_R_G_L_3_G'>
        <path
          id='_R_G_L_3_G_D_0_P_0'
          fill='#e4e4e4'
          fillOpacity='1'
          fillRule='nonzero'
          d=' M-152.44 -34.12 C-136.94,-34.12 -124.36,-21.54 -124.36,-6.03 C-124.36,9.47 -136.94,22.05 -152.44,22.05 C-167.95,22.05 -180.53,9.47 -180.53,-6.03 C-180.53,-21.54 -167.95,-34.12 -152.44,-34.12z '
        />
        <path
          id='_R_G_L_3_G_D_1_P_0'
          stroke='#ffffff'
          strokeLinecap='round'
          strokeLinejoin='round'
          fill='none'
          strokeWidth='0'
          strokeOpacity='1'
          d=' M-152.44 -34.12 C-136.94,-34.12 -124.36,-21.54 -124.36,-6.03 C-124.36,9.47 -136.94,22.05 -152.44,22.05 C-167.95,22.05 -180.53,9.47 -180.53,-6.03 C-180.53,-21.54 -167.95,-34.12 -152.44,-34.12z '
        />
      </g>
      <g id='_R_G_L_2_G'>
        <path
          id='_R_G_L_2_G_D_0_P_0'
          fill='#e4e4e4'
          fillOpacity='1'
          fillRule='nonzero'
          d=' M-152.44 -34.12 C-136.94,-34.12 -124.36,-21.54 -124.36,-6.03 C-124.36,9.47 -136.94,22.05 -152.44,22.05 C-167.95,22.05 -180.53,9.47 -180.53,-6.03 C-180.53,-21.54 -167.95,-34.12 -152.44,-34.12z '
        />
        <path
          id='_R_G_L_2_G_D_1_P_0'
          stroke='#ffffff'
          strokeLinecap='round'
          strokeLinejoin='round'
          fill='none'
          strokeWidth='0'
          strokeOpacity='1'
          d=' M-152.44 -34.12 C-136.94,-34.12 -124.36,-21.54 -124.36,-6.03 C-124.36,9.47 -136.94,22.05 -152.44,22.05 C-167.95,22.05 -180.53,9.47 -180.53,-6.03 C-180.53,-21.54 -167.95,-34.12 -152.44,-34.12z '
        />
      </g>
      <g id='_R_G_L_1_G'>
        <path
          id='_R_G_L_1_G_D_0_P_0'
          fill='#e4e4e4'
          fillOpacity='1'
          fillRule='nonzero'
          d=' M-152.44 -34.12 C-136.94,-34.12 -124.36,-21.54 -124.36,-6.03 C-124.36,9.47 -136.94,22.05 -152.44,22.05 C-167.95,22.05 -180.53,9.47 -180.53,-6.03 C-180.53,-21.54 -167.95,-34.12 -152.44,-34.12z '
        />
        <path
          id='_R_G_L_1_G_D_1_P_0'
          stroke='#ffffff'
          strokeLinecap='round'
          strokeLinejoin='round'
          fill='none'
          strokeWidth='0'
          strokeOpacity='1'
          d=' M-152.44 -34.12 C-136.94,-34.12 -124.36,-21.54 -124.36,-6.03 C-124.36,9.47 -136.94,22.05 -152.44,22.05 C-167.95,22.05 -180.53,9.47 -180.53,-6.03 C-180.53,-21.54 -167.95,-34.12 -152.44,-34.12z '
        />
      </g>
      <g id='_R_G_L_0_G'>
        <path
          id='_R_G_L_0_G_D_0_P_0'
          fill='#e4e4e4'
          fillOpacity='1'
          fillRule='nonzero'
          d=' M-152.44 -34.12 C-136.94,-34.12 -124.36,-21.54 -124.36,-6.03 C-124.36,9.47 -136.94,22.05 -152.44,22.05 C-167.95,22.05 -180.53,9.47 -180.53,-6.03 C-180.53,-21.54 -167.95,-34.12 -152.44,-34.12z '
        />
        <path
          id='_R_G_L_0_G_D_1_P_0'
          stroke='#ffffff'
          strokeLinecap='round'
          strokeLinejoin='round'
          fill='none'
          strokeWidth='0'
          strokeOpacity='1'
          d=' M-152.44 -34.12 C-136.94,-34.12 -124.36,-21.54 -124.36,-6.03 C-124.36,9.47 -136.94,22.05 -152.44,22.05 C-167.95,22.05 -180.53,9.47 -180.53,-6.03 C-180.53,-21.54 -167.95,-34.12 -152.44,-34.12z '
        />
      </g>
    </g>
    <g id='time_group' />
  </svg>,
  'Loading',
);

export const UKFlagIcon = createSvgIcon(
  <svg xmlns='http://www.w3.org/2000/svg' id='flag-icons-gb' viewBox='0 0 640 480'>
    <path fill='#012169' d='M0 0h640v480H0z' />
    <path
      fill='#FFF'
      d='m75 0 244 181L562 0h78v62L400 241l240 178v61h-80L320 301 81 480H0v-60l239-178L0 64V0z'
    />
    <path
      fill='#C8102E'
      d='m424 281 216 159v40L369 281zm-184 20 6 35L54 480H0zM640 0v3L391 191l2-44L590 0zM0 0l239 176h-60L0 42z'
    />
    <path fill='#FFF' d='M241 0v480h160V0zM0 160v160h640V160z' />
    <path fill='#C8102E' d='M0 193v96h640v-96zM273 0v480h96V0z' />
  </svg>,
  'UKFlag',
);

export const GermanyFlagIcon = createSvgIcon(
  <svg xmlns='http://www.w3.org/2000/svg' id='flag-icons-de' viewBox='0 0 640 480'>
    <path fill='#fc0' d='M0 320h640v160H0z' />
    <path fill='#000001' d='M0 0h640v160H0z' />
    <path fill='red' d='M0 160h640v160H0z' />
  </svg>,
  'GermanyFlag',
);

export const FranceFlagIcon = createSvgIcon(
  <svg xmlns='http://www.w3.org/2000/svg' id='flag-icons-fr' viewBox='0 0 640 480'>
    <path fill='#fff' d='M0 0h640v480H0z' />
    <path fill='#000091' d='M0 0h213.3v480H0z' />
    <path fill='#e1000f' d='M426.7 0H640v480H426.7z' />
  </svg>,
  'FranceFlag',
);

export const ItalyFlagIcon = createSvgIcon(
  <svg xmlns='http://www.w3.org/2000/svg' id='flag-icons-it' viewBox='0 0 640 480'>
    <path fill='#fff' d='M0 0h640v480H0z' />
    <path fill='#009246' d='M0 0h213.3v480H0z' />
    <path fill='#ce2b37' d='M426.7 0H640v480H426.7z' />
  </svg>,
  'ItalyFlag',
);

export const AddInfoIcon = createSvgIcon(
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C13.7911 22 15.4726 21.5283 16.9272 20.7025L15.574 19.1559C14.4976 19.6959 13.2835 20 12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C15.7197 4 18.856 6.55407 19.7467 10H21.7997C20.8723 5.4373 16.8351 2 12 2Z'
      fill='currentColor'
    />
    <path d='M13 9V7H11V9H13Z' fill='currentColor' />
    <path d='M13 17V11H11V17H13Z' fill='currentColor' />
    <path
      d='M16 14.8008H19V11.8008H21V14.8008H24V16.8008H21V19.8008H19V16.8008H16V14.8008Z'
      fill='currentColor'
    />
  </svg>,
  'AddInfoIcon',
);

export const CoinsMoney = createSvgIcon(
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='currentColor'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M15.0744 17.9024V20.0983C15.0744 20.4858 14.3598 21.103 12.7816 21.5479C10.5931 22.1507 7.49628 22.1507 5.30769 21.5479C3.78908 21.1173 3 20.5002 3 20.0983V17.8881C4.44417 18.7348 6.75186 19.1654 9.04466 19.1654C11.3375 19.1654 13.6303 18.7348 15.0744 17.9024Z' />
    <path d='M15.0744 15.8213C15.0744 16.582 12.6774 17.7302 9.04466 17.7302C5.41191 17.7302 3 16.582 3 15.8213C3 15.0606 5.41191 13.9125 9.04466 13.9125C12.6774 13.9125 15.0744 15.0606 15.0744 15.8213Z' />
    <path d='M21 14.5153V16.7255C21 17.113 20.2705 17.7445 18.6923 18.1751C18.0372 18.3617 17.3077 18.4621 16.5633 18.5339V15.8213C16.5633 15.8213 16.5633 15.7352 16.5484 15.6921C17.4566 15.6204 18.335 15.4912 19.0943 15.2759C19.8536 15.075 20.4789 14.8023 21 14.5153Z' />
    <path d='M21 10.2382V12.4485C21 12.836 20.2705 13.4532 18.6774 13.8981C17.8437 14.1421 16.861 14.2713 15.8486 14.3143C14.5533 13.1087 11.7246 12.5203 8.92556 12.5346V10.2382C9.43176 10.5396 10.0571 10.798 10.8015 11.0133C12.0223 11.3434 13.4665 11.53 14.9553 11.53C16.4442 11.53 17.8883 11.3434 19.1092 11.0133C19.8536 10.798 20.4789 10.5396 21 10.2382Z' />
    <path d='M21 5.9756V8.18586C21 8.58773 20.2109 9.20488 18.6923 9.6211C16.5186 10.2239 13.4069 10.2382 11.2184 9.6211C9.71464 9.20488 8.92556 8.58773 8.92556 8.18586V5.9756C10.3697 6.82239 12.6625 7.25296 14.9553 7.25296C17.2481 7.25296 19.5558 6.82239 21 5.9756Z' />
    <path d='M21 3.90886C20.9851 4.28202 20.3896 4.77 19.3325 5.14317C18.2754 5.53068 16.7717 5.81773 14.9553 5.81773C11.3375 5.81773 8.92556 4.66954 8.92556 3.90886C8.92556 3.5357 9.52109 3.04772 10.5782 2.67456C11.6352 2.28705 13.139 2 14.9553 2C18.5881 2 21 3.14819 21 3.90886Z' />
  </svg>,
  'CoinsMoney',
);

export const ImportIcon = createSvgIcon(
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M14.59 13.58L16 14.99L11.99 19L8 14.99L9.41 13.57L11 15.16V11H13L13 15.16L14.59 13.58Z'
      fill='black'
      fill-opacity='0.56'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M6 2H14L20 8V20C20 21.1 19.1 22 18 22H5.99C4.89 22 4 21.1 4 20L4.01 4C4.01 2.9 4.9 2 6 2ZM6 20H18V9H13V4H6V20Z'
      fill='black'
      fill-opacity='0.56'
    />
  </svg>,
  'ImportIcon',
);

export const MorgengoldIcon = createSvgIcon(
  <svg width='24' height='21' xmlns='http://www.w3.org/2000/svg' version='1.1'>
    <path
      d='m18.4,14.79c-0.92,0.19 -1.91,-0.03 -2.69,-0.58c-0.41,-0.29 -0.77,-0.55 -1.16,-0.85c1.15,-1 2.69,-2.36 4.85,-4.29c1.06,1.06 1.95,2.62 0.88,4.42c-0.4,0.67 -1.07,1.13 -1.88,1.3m-12.84,0c-0.81,-0.17 -1.48,-0.63 -1.88,-1.3c-1.07,-1.8 -0.2,-3.35 0.88,-4.42c2.16,1.93 3.7,3.29 4.86,4.29c-0.39,0.29 -0.75,0.55 -1.17,0.85c-0.78,0.55 -1.77,0.77 -2.69,0.58m6.52,-8.53l0,-0.01c0.61,-0.01 2.49,0.05 4.51,0.93c-2.1,1.86 -3.54,3.14 -4.62,4.06c-1.07,-0.92 -2.51,-2.19 -4.61,-4.06c2.01,-0.88 3.89,-0.94 4.51,-0.93l0,0.01c0.01,0 0.04,0 0.1,-0.01c0.07,0.01 0.1,0.01 0.11,0.01m11.78,4.02c-0.31,-1.22 -0.98,-2.36 -1.99,-3.39l1.34,-1.19c0.16,-0.14 0.18,-0.41 0.03,-0.56l-1.69,-1.84c-0.16,-0.17 -0.42,-0.17 -0.57,-0.02l-1.78,1.58c-3.07,-1.76 -6.16,-1.88 -7.22,-1.86c-1.06,-0.02 -4.14,0.09 -7.22,1.86l-1.77,-1.57c-0.15,-0.14 -0.41,-0.14 -0.57,0.03l-1.7,1.84c-0.14,0.15 -0.13,0.42 0.03,0.55l1.33,1.19c-1.02,1.03 -1.68,2.16 -1.99,3.39c-0.42,1.63 -0.15,3.36 0.74,4.85c0.88,1.47 2.32,2.48 4.06,2.83c0.44,0.09 0.9,0.14 1.34,0.14c1.41,0 2.8,-0.44 3.96,-1.27c0.63,-0.45 1.14,-0.81 1.79,-1.33c0.65,0.52 1.17,0.88 1.79,1.33c1.17,0.83 2.55,1.27 3.96,1.27c0.44,0 0.9,-0.04 1.34,-0.14c1.73,-0.35 3.17,-1.36 4.06,-2.83c0.9,-1.5 1.16,-3.22 0.74,-4.85'
      fill='black'
      fill-opacity='0.56'
      id='svg_3'
    />
  </svg>,
  'MorgengoldIcon',
);

export const RightExpandArrow = createSvgIcon(
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M14.59 7.41L18.17 11H6V13H18.17L14.58 16.59L16 18L22 12L16 6L14.59 7.41ZM2 6V18H4V6H2Z'
      fill='currentColor'
    />
  </svg>,
  'StartExpandArrow',
);

export const LeftExpandArrow = createSvgIcon(
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M9.41 16.59L5.83 13L18 13L18 11L5.83 11L9.42 7.41L8 6L2 12L8 18L9.41 16.59ZM22 18L22 6L20 6L20 18L22 18Z'
      fill='currentColor'
    />
  </svg>,
  'LeftExpandArrow',
);

export const AiSmallButton = createSvgIcon(
  <svg width='34' height='34' viewBox='0 0 34 34' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <mask id='path-1-inside-1_7227_29367' fill='white'>
      <path d='M0 17C0 7.61116 7.61116 0 17 0H34V34H17C7.61116 34 0 26.3888 0 17Z' />
    </mask>
    <path d='M0 17C0 7.61116 7.61116 0 17 0H34V34H17C7.61116 34 0 26.3888 0 17Z' fill='white' />
    <path
      d='M-1 17C-1 7.05887 7.05887 -1 17 -1H34V1H17C8.16344 1 1 8.16344 1 17H-1ZM34 35H17C7.05887 35 -1 26.9411 -1 17H1C1 25.8366 8.16344 33 17 33H34V35ZM17 35C7.05887 35 -1 26.9411 -1 17C-1 7.05887 7.05887 -1 17 -1V1C8.16344 1 1 8.16344 1 17C1 25.8366 8.16344 33 17 33V35ZM34 0V34V0Z'
      fill='#2196F3'
      mask='url(#path-1-inside-1_7227_29367)'
    />
    <path
      d='M19.8417 20.825L16.0251 17L19.8417 13.175L18.6667 12L13.6667 17L18.6667 22L19.8417 20.825Z'
      fill='black'
      fill-opacity='0.38'
    />
  </svg>,
  'AiSmallButton',
);
